/**
 * The onboarding wizard is mounted once, in AgentOnboardingGate (App.tsx),
 * outside every page. Surfaces that want it open — the Explore fit-scores
 * card, the story panel's "Set preferences", Settings — call
 * requestAgentOnboarding(); the gate listens and opens the modal. When the
 * wizard's write lands, the gate announces completion so those surfaces can
 * update without a reload (spec 2026-09-24 §8).
 *
 * Browser-only: every function is a no-op without `window`, so a prerender
 * or Node test that imports this module is unaffected.
 */

const REQUEST = "compaire:agent-onboarding-request";
const COMPLETED = "compaire:agent-onboarding-completed";

const emit = (type: string) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(type));
};

const listen = (type: string, cb: () => void): (() => void) => {
  if (typeof window === "undefined") return () => {};
  const handler = () => cb();
  window.addEventListener(type, handler);
  return () => window.removeEventListener(type, handler);
};

export const requestAgentOnboarding = () => emit(REQUEST);
export const onAgentOnboardingRequest = (cb: () => void) => listen(REQUEST, cb);
export const announceAgentOnboardingCompleted = () => emit(COMPLETED);
export const onAgentOnboardingCompleted = (cb: () => void) => listen(COMPLETED, cb);
